import { Controller } from "@hotwired/stimulus"
import { parse } from "postcss"

// Connects to data-controller="campaign"
export default class extends Controller {
  static targets = ["platform", "kind", "linkExample", "quantity", "price"]
  static values = { prices: Array }

  connect() {
    this.price_per_one = 0
  }

  selectPlatform(event) {
    if (event.currentTarget.value) {
      this.kindTarget.disabled = false

      this.kindTarget.querySelectorAll('option').forEach((option) => {
        if (option.value != "")
          option.remove()
      })

      this.pricesValue.forEach((price) => {
        if (price.platform == event.currentTarget.value) {
          this.kindTarget.innerHTML += `<option value="${price.kind}">${price.kind_name}: ${price.amount} ${this.element.dataset.currency}</option>`
        }
      })
    } else {
      this.kindTarget.disabled = true
    }

    this.kindTarget.value = ""
    this.linkExampleTarget.innerHTML = ""
    this.quantityTarget.value = ""
    this.quantityTarget.disabled = true
    this.priceTarget.value = ""
  }

  selectKind(event) {
    if (event.currentTarget.value) {
      this.selectedPlatformAndKind = this.pricesValue.find(price => price.platform == this.platformTarget.value && price.kind == event.currentTarget.value)

      // link example
      this.linkExampleTarget.innerHTML = this.selectedPlatformAndKind.link

      this.price_per_one = this.selectedPlatformAndKind.amount
      if (this.quantityTarget.value) {
        this.priceTarget.value = this.price_per_one * parseInt(this.quantityTarget.value)
      }

      this.quantityTarget.disabled = false
    } else {
      this.linkExampleTarget.innerHTML = ""

      this.price_per_one = 0
      this.quantityTarget.value = ""
      this.quantityTarget.disabled = true
      this.priceTarget.value = ""
    }
  }

  changeQuantity(event) {
    this.priceTarget.value = this.price_per_one * parseInt(event.currentTarget.value || 0)
  }
}
